import styles from './NewsletterCard.module.css';

type NewsletterCardProps = {
  imageUrl: string;
  title: string;
  description: string;
  buttonUrl: string;
};

const NewsletterCardContainer = (props: NewsletterCardProps) => {
  return (
    <div className={styles.newsletterCard}>
      <div className={styles.imageContainer}>
        <img className={styles.image} src={props.imageUrl} />
        {/* <div className={styles.newsletterSmallButton}>{props.cadence}</div> */}
      </div>
      <div className={styles.newsletterDynamicsLabel}>{props.title}</div>
      <div className={styles.newsletterDescriptionLabel}>{props.description}</div>
      <div className={styles.bottomContainer}>
        <div className={styles.manageSubscriptionsButtonContainer}>
          <a href={props.buttonUrl} target='_blank'>
            <div className={styles.manageSubscriptionsButton}>LEARN MORE</div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default NewsletterCardContainer;
